export default function Footer() {
  const services = ['Drug Discovery', 'Clinical Trials', 'Biosensors', 'Regulatory Affairs'];
  const company = ['About Us', 'Careers', 'News', 'Contact'];

  return (
    <footer style={{ background: 'linear-gradient(180deg, #0a0a12 0%, #06060e 100%)', borderTop: '1px solid rgba(201,168,76,0.15)' }} className="py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="mb-6 flex items-center gap-3">
              <div className="w-9 h-9 flex items-center justify-center" style={{ background: 'rgba(201,168,76,0.1)', border: '1px solid rgba(201,168,76,0.3)', borderRadius: '8px' }}>
                <i className="ri-flashlight-line" style={{ color: '#c9a84c' }} />
              </div>
              <div>
                <h3
                  className="text-xl font-bold tracking-[0.12em] uppercase"
                  style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c87a)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}
                >
                  Éclat-Gen
                </h3>
                <p className="text-xs tracking-[0.2em] uppercase font-light" style={{ color: 'rgba(201,168,76,0.5)' }}>Brilliance. Engineered.</p>
              </div>
            </div>
            <p className="text-sm text-white/35 mb-8 max-w-sm font-light leading-relaxed">
              AI-powered strategic consulting across industries, empowering organizations through intelligent systems and digital transformation solutions
            </p>
            <div className="flex space-x-3">
              {['ri-linkedin-fill', 'ri-twitter-fill', 'ri-facebook-fill'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  className="w-9 h-9 flex items-center justify-center cursor-pointer transition-all duration-300 hover:scale-110"
                  style={{ background: 'rgba(201,168,76,0.08)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '6px' }}
                >
                  <i className={`${icon} text-sm`} style={{ color: 'rgba(201,168,76,0.7)' }} />
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.2em] uppercase mb-6" style={{ color: '#c9a84c' }}>Services</h4>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s}>
                  <a href="#" className="text-sm text-white/35 hover:text-[#c9a84c] cursor-pointer font-light transition-colors duration-300">{s}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-semibold tracking-[0.2em] uppercase mb-6" style={{ color: '#c9a84c' }}>Company</h4>
            <ul className="space-y-3">
              {company.map((c) => (
                <li key={c}>
                  <a href="#" className="text-sm text-white/35 hover:text-[#c9a84c] cursor-pointer font-light transition-colors duration-300">{c}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Disclaimers */}
        <div className="mt-14 space-y-4">
          <div className="p-5 flex items-start gap-4" style={{ background: 'rgba(201,168,76,0.04)', border: '1px solid rgba(201,168,76,0.15)', borderRadius: '8px' }}>
            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: 'rgba(201,168,76,0.1)', borderRadius: '6px' }}>
              <i className="ri-alert-line text-sm" style={{ color: '#c9a84c' }} />
            </div>
            <div>
              <h4 className="text-sm font-semibold text-white/70 mb-1.5">Not a Substitute for Professional Medical Advice</h4>
              <p className="text-xs text-white/35 font-light leading-relaxed">
                Information provided is for research and educational purposes only. Always consult a qualified healthcare professional for medical advice or treatment.
              </p>
            </div>
          </div>
          <div className="p-5 flex items-start gap-4" style={{ background: 'rgba(201,168,76,0.04)', border: '1px solid rgba(201,168,76,0.12)', borderRadius: '8px' }}>
            <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: 'rgba(201,168,76,0.08)', borderRadius: '6px' }}>
              <i className="ri-information-line text-sm" style={{ color: '#c9a84c' }} />
            </div>
            <div>
              <h4 className="text-sm font-semibold text-white/70 mb-1.5">Experimental Website Notice</h4>
              <p className="text-xs text-white/35 font-light leading-relaxed">
                This website is under development with AI-generated content for demonstration purposes. All data and characters are hypothetical and do not represent real entities.
              </p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-8 flex flex-col md:flex-row justify-between items-center" style={{ borderTop: '1px solid rgba(201,168,76,0.1)' }}>
          <p className="text-xs text-white/25 font-light tracking-wide">© 2025 Éclat-Gen. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-xs text-white/25 hover:text-[#c9a84c] cursor-pointer font-light transition-colors duration-300">Privacy Policy</a>
            <a href="#" className="text-xs text-white/25 hover:text-[#c9a84c] cursor-pointer font-light transition-colors duration-300">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
